module.exports = __webpack_public_path__ + "static/People3-3x-4c082c5b2fb0bae50f7d7f0082bab8e6.png";